import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "main-container" };
const _hoisted_2 = { class: "notice" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_StartScreen = _resolveComponent("StartScreen");
    const _component_CreateGameForm = _resolveComponent("CreateGameForm");
    const _component_LoadGameForm = _resolveComponent("LoadGameForm");
    const _component_GameHome = _resolveComponent("GameHome");
    const _component_PlayerHome = _resolveComponent("PlayerHome");
    const _component_SpectatorHome = _resolveComponent("SpectatorHome");
    const _component_SetupTable = _resolveComponent("SetupTable");
    const _component_GameEnd = _resolveComponent("GameEnd");
    const _component_GamesOverview = _resolveComponent("GamesOverview");
    const _component_CardList = _resolveComponent("CardList");
    const _component_AdminHome = _resolveComponent("AdminHome");
    const _component_LoginHome = _resolveComponent("LoginHome");
    const _component_Help = _resolveComponent("Help");
    const _component_AccountLogin = _resolveComponent("AccountLogin");
    const _component_MyGames = _resolveComponent("MyGames");
    const _component_JoinRoom = _resolveComponent("JoinRoom");
    const _component_AccountTag = _resolveComponent("AccountTag");
    const _component_UiScaleControl = _resolveComponent("UiScaleControl");
    const _directive_i18n = _resolveDirective("i18n");
    return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass('topmost-' + _ctx.screen)
    }, [
        _createElementVNode("div", _hoisted_1, [
            (_ctx.screen === 'start-screen')
                ? (_openBlock(), _createBlock(_component_StartScreen, { key: 0 }))
                : (_ctx.screen === 'create-game-form')
                    ? (_openBlock(), _createBlock(_component_CreateGameForm, { key: 1 }))
                    : (_ctx.screen === 'load')
                        ? (_openBlock(), _createBlock(_component_LoadGameForm, { key: 2 }))
                        : (_ctx.screen === 'game-home' && _ctx.game !== undefined)
                            ? (_openBlock(), _createBlock(_component_GameHome, {
                                key: 3,
                                game: _ctx.game
                            }, null, 8, ["game"]))
                            : (_ctx.screen === 'player-home' && _ctx.playerView !== undefined)
                                ? (_openBlock(), _createBlock(_component_PlayerHome, {
                                    key: 4,
                                    "player-view": _ctx.playerView
                                }, null, 8, ["player-view"]))
                                : (_ctx.screen === 'spectator-home' && _ctx.spectator !== undefined)
                                    ? (_openBlock(), _createBlock(_component_SpectatorHome, {
                                        key: 5,
                                        spectator: _ctx.spectator
                                    }, null, 8, ["spectator"]))
                                    : (_ctx.screen === 'setup-table' && _ctx.lobby !== undefined)
                                        ? (_openBlock(), _createBlock(_component_SetupTable, {
                                            key: 6,
                                            lobby: _ctx.lobby
                                        }, null, 8, ["lobby"]))
                                        : (_ctx.screen === 'the-end' && _ctx.participant !== undefined)
                                            ? (_openBlock(), _createBlock(_component_GameEnd, {
                                                key: 7,
                                                participant: _ctx.participant
                                            }, null, 8, ["participant"]))
                                            : (_ctx.screen === 'games-overview')
                                                ? (_openBlock(), _createBlock(_component_GamesOverview, { key: 8 }))
                                                : (_ctx.screen === 'cards')
                                                    ? (_openBlock(), _createBlock(_component_CardList, { key: 9 }))
                                                    : (_ctx.screen === 'admin')
                                                        ? (_openBlock(), _createBlock(_component_AdminHome, { key: 10 }))
                                                        : (_ctx.screen === 'login-home')
                                                            ? (_openBlock(), _createBlock(_component_LoginHome, { key: 11 }))
                                                            : (_ctx.screen === 'help')
                                                                ? (_openBlock(), _createBlock(_component_Help, { key: 12 }))
                                                                : (_ctx.screen === 'account')
                                                                    ? (_openBlock(), _createBlock(_component_AccountLogin, { key: 13 }))
                                                                    : (_ctx.screen === 'my-games')
                                                                        ? (_openBlock(), _createBlock(_component_MyGames, { key: 14 }))
                                                                        : (_ctx.screen === 'join')
                                                                            ? (_openBlock(), _createBlock(_component_JoinRoom, { key: 15 }))
                                                                            : _createCommentVNode("", true)
        ]),
        (_ctx.screen === 'player-home' || _ctx.screen === 'setup-table')
            ? (_openBlock(), _createBlock(_component_AccountTag, { key: 0 }))
            : _createCommentVNode("", true),
        _createVNode(_component_UiScaleControl),
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[0] || (_cache[0] = [
                _createTextVNode(" Not affiliated with FryxGames, Asmodee Digital or Steam in any way. ", -1)
            ]))])), [
            [_directive_i18n]
        ])
    ], 2));
}
